import { makeStyles } from '@mui/styles';
import { body1, caption, heading1 } from '../../shared/theme/text.styles';
export const useAboutPageStyles = makeStyles((theme) => ({
  ourMission: {
    color: theme.palette.primary.main,
    textTransform: 'capitalize',
    fontWeigth: '600 !important',
    ...caption,
  },

  apWrapper: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column',
    },
  },

  misson: {
    ...heading1,
  },

  aboutCompany: {
    ...body1,
    whiteSpace: 'pre-wrap'
  },
}));
